import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { DomainDefinitionService } from '../../builder/services/domain-definition.service';
import { LettersService } from "../letters.service";

import { AddressDomain } from "../../builder/models/domain.model";
import { Letter, LetterAddress } from '../letters.model';

@Component({
    selector: 'letter-detail-wrapper',
    templateUrl: './letter-detail-wrapper.component.html',
    styleUrls: ['./letter-detail-wrapper.component.scss'],
    standalone: false
})
export class LetterDetailWrapperComponent implements OnInit, OnDestroy {

    public _id: string;
    public _flowId: string;
    public _routeSubscription: Subscription;

    offices: Observable<LetterAddress[]>;
    record: Observable<Letter>;

    constructor(
        public route: ActivatedRoute,
        public lettersService: LettersService,
        public _domainService: DomainDefinitionService
    ) { }

    get flowId(): string {
        return this._flowId;
    }

    ngOnInit() {
        this._routeSubscription = this.route.params.subscribe(p => {
            if (p["id"]) {
                this._id = p["id"];
                this.record = this.lettersService.get(this._id);
            }
            if (p["flowId"]) {
                    this._flowId = p["flowId"];
            }
            this.offices = this._domainService.getValues("ODNR_LOCATIONS").pipe(map((addressDomains: AddressDomain[]) => {
                return addressDomains.map((addressDomain: AddressDomain) => this.lettersService.mapDomainToSnailMailAddress(addressDomain));
            }));
        });
    }

    ngOnDestroy(): void {
        if (this._routeSubscription) {
            this._routeSubscription.unsubscribe();
        }
    }

}
